module.exports = __webpack_public_path__ + "img/Hero_Image.c48b77f7.png";